import { namespacer } from 'helpers'

const namespace = namespacer('FORM_GROUP')
export const EDIT_FORM = namespace('EDIT_FORM')
export const CLOSE_FORM = namespace('CLOSE_FORM')
